import { LogLevel as i } from "./types.mjs";
class o {
  constructor(t) {
    this.logStrategy = t;
  }
  format(t) {
    return this.logStrategy.format ? this.logStrategy.format(t) : t;
  }
  sanitize(t) {
    return this.logStrategy.sanitize ? this.logStrategy.sanitize(t) : t;
  }
  setLogStrategy(t) {
    this.logStrategy = t;
  }
  verbose(t, e) {
    this.logStrategy.execute(
      i.Verbose,
      t,
      this.format(this.sanitize(e))
    );
  }
  debug(t, e) {
    this.logStrategy.execute(
      i.Debug,
      t,
      this.format(this.sanitize(e))
    );
  }
  info(t, e) {
    this.logStrategy.execute(
      i.Information,
      t,
      this.format(this.sanitize(e))
    );
  }
  warn(t, e) {
    this.logStrategy.execute(
      i.Warning,
      t,
      this.format(this.sanitize(e))
    );
  }
  error(t, e, r) {
    this.logStrategy.execute(
      i.Error,
      t,
      this.format(this.sanitize(e)),
      r
    );
  }
  fatal(t, e) {
    this.logStrategy.execute(
      i.Fatal,
      t,
      this.format(this.sanitize(e))
    );
  }
}
export {
  o as default
};
